(function(){
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (root.classList.contains('no-motion') || reduce) return;

  /* ---- jelly : la page reagit a la vitesse de scroll ---- */
  var last = window.pageYOffset, vel = 0, cur = 0, running = false;
  function frame(){
    cur += (vel - cur) * 0.14;
    vel *= 0.86;
    var v = Math.max(-2.6, Math.min(2.6, cur * 0.055));
    root.style.setProperty('--jy', v.toFixed(3));
    root.style.setProperty('--jyabs', Math.abs(v).toFixed(3));
    if (Math.abs(cur) > 0.03 || Math.abs(vel) > 0.03) { requestAnimationFrame(frame); }
    else { root.style.setProperty('--jy', 0); root.style.setProperty('--jyabs', 0); running = false; }
  }
  window.addEventListener('scroll', function(){
    var y = window.pageYOffset;
    vel += (y - last);
    last = y;
    if (!running) { running = true; requestAnimationFrame(frame); }
  }, { passive: true });

  /* ---- apparition avec rebond ---- */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e, i){
      if (e.isIntersecting){
        setTimeout(function(){ e.target.classList.add('in'); }, i * 70);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  /* ---- halo liquide qui suit le curseur dans le hero ---- */
  document.querySelectorAll('.hero').forEach(function(hero){
    var glow = hero.querySelector('.hero__glow');
    if (!glow) return;
    var tx = hero.offsetWidth * 0.5, ty = hero.offsetHeight * 0.5, x = tx, y = ty, on = false;
    function loop(){
      x += (tx - x) * 0.07; y += (ty - y) * 0.07;
      glow.style.left = x + 'px'; glow.style.top = y + 'px';
      if (on) requestAnimationFrame(loop);
    }
    hero.addEventListener('pointermove', function(e){
      var r = hero.getBoundingClientRect();
      tx = e.clientX - r.left; ty = e.clientY - r.top;
      if (!on){ on = true; requestAnimationFrame(loop); }
    });
    hero.addEventListener('pointerleave', function(){
      tx = hero.offsetWidth * 0.5; ty = hero.offsetHeight * 0.55;
      setTimeout(function(){ on = false; }, 900);
    });
  });
})();
